import { Component, OnInit } from '@angular/core';
import { Share } from '@capacitor/share';
import { ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseCrashlyticsService } from '@shared/services/firebase-crashlytics.service';

@Component({
  selector: 'app-share-profile',
  templateUrl: './share-profile.component.html',
  styleUrls: ['./share-profile.component.scss'],
})
export class ShareProfileComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userId: any;
  /** URL base para o link de compartilhamento (ex.: https://app.veggly.net ou https://web.fyradating.com). */
  private shareBaseUrl: string = 'https://app.veggly.net';
  /** Chave i18n do texto do share (ex.: checkVegglyMsg ou shareYourProfileText). */
  private shareTextKey: string = 'checkVegglyMsg';
  /** Chave i18n do título do share (ex.: checkVegglyTitle ou shareYourProfile). */
  private shareTitleKey: string = 'checkVegglyTitle';

  constructor(
    public firebaseCrashlytics: FirebaseCrashlyticsService,
    public translate: TranslateService, private navParams: NavParams, private modalController: ModalController) { }

  ngOnInit() {
    this.userId = this.navParams.get('userId');
    this.shareBaseUrl = this.navParams.get('shareBaseUrl') ?? this.shareBaseUrl;
    this.shareTextKey = this.navParams.get('shareTextKey') ?? this.shareTextKey;
    this.shareTitleKey = this.navParams.get('shareTitleKey') ?? this.shareTitleKey;
  }

  goBack() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  profileShare() {
    const base = this.shareBaseUrl.replace(/\?$/, '').replace(/\/*$/, '');
    const sep = base.includes('?') ? '&' : '?';
    const shareUrl = base + sep + 'referralUserId=' + this.userId;
    Share.share({
      text: this.translate.instant(this.shareTextKey) + ' ' + shareUrl,
      title: this.translate.instant(this.shareTitleKey)
    }).then((sucess) => {
      console.log('share succesfull: ' + JSON.stringify(sucess));
    }).catch((error) => {
      this.firebaseCrashlytics.log('share unsuccesfull: ' + JSON.stringify(error));
    });
  }

}
